import type { Office } from '../../../components/firms/firm/mapper'

/**
 * Get the address of an office
 * @param office - The office to get the address of the office
 * @returns The address of the office
 */
export function getOfficeAddress(office: Office) {
  if (!office) {
    return ''
  }
  const strings = []
  const { street, city, postalCode } = office

  if (street) {
    strings.push(`${street},`)
  }

  if (city) {
    strings.push(city)
  }

  if (postalCode) {
    strings.push(`(${postalCode.slice(0, 2)})`)
  }

  return strings.join(' ')
}
